import { Button, Col } from "@commonlibs";
import { Link } from "react-router-dom";
import Logo from "ui/common/components/display/Logo/Logo";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import { NotFound404Text, NotFoundPageRoot, NotFoundText } from "./NotFoundPage.styles";
import useIsLoggedIn from "ui/auth/hooks/useIsLoggedIn";

const NotFoundPage = (): JSX.Element => {
    const isLoggedIn = useIsLoggedIn();
    const translateError = useTranslate("error");
    const translate = useTranslate();

    return (
        <NotFoundPageRoot isLoggedIn={isLoggedIn}>
            <Logo color={isLoggedIn ? "primary" : "white"} size="md" />
            <NotFound404Text variant="h2Strong" isLoggedIn={isLoggedIn}>
                404
            </NotFound404Text>
            <Col alignItems="center" gap="0.5rem">
                <NotFoundText variant="h3Strong" isLoggedIn={isLoggedIn}>
                    {translateError("notFound")}
                </NotFoundText>
                <NotFoundText variant="body1Regular" isLoggedIn={isLoggedIn}>
                    {translateError("content404")}
                </NotFoundText>
            </Col>
            <Link to={MainRoutes.MAIN}>
                <Button variant={isLoggedIn ? "secondary" : "primary"}>{translate("backToHome")}</Button>
            </Link>
        </NotFoundPageRoot>
    );
};

export default NotFoundPage;
